/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable import/no-extraneous-dependencies */
import './index.css';
import {
  BsGithub, BsStackOverflow, BsLinkedin, BsTwitter,
} from 'react-icons/bs';
import { AiOutlineMedium } from 'react-icons/ai';
import { FaAngellist } from 'react-icons/fa';

const HeaderSocial = () => (
  <div className="header_social">
    <a href="https://www.linkedin.com/in/abdul-jalloh" target="_blank" rel="noreferrer"><BsLinkedin /></a>
    <a href="https://github.com/aradradev" target="_blank" rel="noreferrer"><BsGithub /></a>
    <a href="https://twitter.com/Abdoul_2023" target="_blank" rel="noreferrer"><BsTwitter /></a>
    <a href="https://medium.com/@aradradev" target="_blank" rel="noreferrer"><AiOutlineMedium /></a>
    <a href="https://stackoverflow.com/users/20558541/jalloh" target="_blank" rel="noreferrer"><BsStackOverflow /></a>
    <a href="https://wellfound.com/u/jalloh" target="_blank" rel="noreferrer"><FaAngellist /></a>
  </div>
);
export default HeaderSocial;
